import { useTranslation } from 'src/hooks';

const useNullOrExceedDataChecking = () => {
  const { t } = useTranslation('clientCreditAllocation');

  const handleNullOrExceedRecords = (
    results: Papa.ParseResult<unknown>
  ): { alertMsg: string | undefined } => {
    //handle no data
    if (results.data.length === 0) {
      return { alertMsg: t('no_record_warning') };
    }

    if (results.data.length === 1) {
      const data = results.data as any[];
      const allValueInFirstRecord = Object.entries(data[0]).filter(([_, value]) => value !== '');
      const isEmptyRecord = allValueInFirstRecord.length === 0;
      if (isEmptyRecord) {
        return { alertMsg: t('no_record_warning') };
      }
    }

    //handle more than 200 records
    if (results.data.length > 200) {
      return { alertMsg: t('maximum_records_warning') };
    }

    return { alertMsg: undefined };
  };

  return { handleNullOrExceedRecords };
};
export default useNullOrExceedDataChecking;
